<div
    class="place-items-center gap-8 grid md:grid-cols-3 px-4 font-futura ~py-8/24"
>
    <!-- left -->
    @if (data().hasAddress) {
        <div data-aos="fade-up" data-aos-duration="500">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 566.93 566.93"
                class="mx-auto md:mx-0 mb-2 size-12"
            >
                <defs>
                    <style>
                        .cls-3 {
                            fill: #d08a44;
                        }
                    </style>
                </defs>
                <path
                    d="M95.18 566.93h391.16c44.51 0 80.59-36.08 80.59-80.59V95.18c0 260.54-211.21 471.75-471.75 471.75"
                    style="fill: #b27939"
                />
                <path
                    class="cls-3"
                    d="M566.3 70.7c.41 8.11.63 16.27.63 24.48V80.59c0-3.35-.23-6.64-.63-9.89"
                />
                <path
                    class="cls-3"
                    d="M486.34 0H80.59C36.08 0 0 36.08 0 80.59v405.75c0 41.16 30.86 75.08 70.7 79.96 8.11.41 16.27.63 24.48.63 260.54 0 471.75-211.21 471.75-471.75q0-12.315-.63-24.48C561.43 30.86 527.5 0 486.34 0"
                />
                <path
                    d="M146.63 106.44c75.4-75.47 198.22-75.47 273.64 0 75.45 75.45 75.45 198.31 0 273.78L283.44 517.08 146.63 380.22c-75.41-75.47-75.41-198.33 0-273.78M283.44 373.2c71.93 0 129.8-57.93 129.8-129.89s-57.87-129.85-129.8-129.85-129.8 57.93-129.8 129.85 57.87 129.89 129.8 129.89"
                    style="fill: #fff"
                />
            </svg>
            <app-rich-text
                class="md:text-left text-center"
                [data]="shopService.config.value()?.data?.address"
            ></app-rich-text>
        </div>
    }

    <!-- center -->
    <div
        class="flex flex-col justify-center items-center md:col-start-2"
        data-aos="fade-up"
        data-aos-duration="500"
    >
        <p class="font-bold text-xl md:text-3xl text-center leading-6">
            {{ data().title }}
        </p>
        <p class="mt-2 text-lg text-center">
            {{ data().subTitle }}
        </p>
        <app-newsletter-input-field></app-newsletter-input-field>
    </div>

    <!-- right -->
    @if (data().hasAddress) {
        <div data-aos="fade-up" data-aos-duration="500">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 566.93 566.93"
                class="mx-auto md:mx-0 mb-2 size-12"
            >
                <defs>
                    <style>
                        .cls-3 {
                            fill: #d08a44;
                        }
                    </style>
                </defs>
                <path
                    d="M95.18 566.93h391.16c44.51 0 80.59-36.08 80.59-80.59V95.18c0 260.54-211.21 471.75-471.75 471.75"
                    style="fill: #b27939"
                />
                <path
                    class="cls-3"
                    d="M566.3 70.7c.41 8.11.63 16.27.63 24.48V80.59c0-3.35-.23-6.64-.63-9.89"
                />
                <path
                    class="cls-3"
                    d="M486.34 0H80.59C36.08 0 0 36.08 0 80.59v405.75c0 41.16 30.86 75.08 70.7 79.96 8.11.41 16.27.63 24.48.63 260.54 0 471.75-211.21 471.75-471.75q0-12.315-.63-24.48C561.43 30.86 527.5 0 486.34 0"
                />
                <path
                    id="Termine"
                    d="M283.48 56.74c-125.01 0-226.72 101.73-226.72 226.72s101.71 226.72 226.72 226.72 226.69-101.71 226.69-226.72S408.49 56.74 283.48 56.74m0 424.55c-109.13 0-197.88-88.74-197.88-197.83S174.36 85.6 283.48 85.6s197.83 88.77 197.83 197.86-88.72 197.83-197.83 197.83m0-370.37c-95.35 0-172.59 77.23-172.59 172.55s77.23 172.55 172.59 172.55 172.55-77.25 172.55-172.55-77.22-172.55-172.55-172.55M149.13 301.19c-9.63 0-17.45-7.83-17.45-17.46s7.81-17.45 17.45-17.45 17.45 7.83 17.45 17.45-7.81 17.46-17.45 17.46M283.5 434.94c-9.63 0-17.45-7.83-17.45-17.45s7.82-17.46 17.45-17.46 17.46 7.83 17.46 17.46-7.81 17.45-17.46 17.45m63.02-88.41c-5.56 5.54-14.56 5.54-20.12 0l-52.97-53.05c-.22-.2-.31-.49-.47-.67-1.05-1.18-1.98-2.44-2.62-3.93-.69-1.73-1.07-3.6-1.07-5.43V150.57c0-7.85 6.34-14.21 14.21-14.21s14.21 6.36 14.21 14.21v126.99l48.83 48.85c5.52 5.54 5.52 14.56 0 20.12m70.73-45.34c-9.61 0-17.45-7.83-17.45-17.46s7.83-17.45 17.45-17.45 17.46 7.83 17.46 17.45-7.83 17.46-17.46 17.46"
                    style="fill: #fff"
                />
            </svg>
            <app-rich-text
                class="md:text-left text-center"
                [data]="shopService.config.value()?.data?.openingHours"
            ></app-rich-text>
        </div>
    }
</div>
